import styled from 'styled-components';

export default styled.ul`
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -${(props) => props.theme.spacing()}px;
`;
